import React, { useState, useEffect } from "react";
import { Form } from "react-bootstrap";

export function YearSelect({ style }) {
  const [selectedYear, setSelectedYear] = useState(() => {
    const saved = localStorage.getItem("tahun_siklus");
    return saved ? parseInt(saved, 10) : new Date().getFullYear();
  });

  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === "tahun_siklus" && e.newValue) {
        setSelectedYear(parseInt(e.newValue, 10));
      }
    };

    const handleCustomChange = (e) => {
      if (e.detail && e.detail.year) {
        setSelectedYear(parseInt(e.detail.year, 10));
      }
    };

    window.addEventListener("storage", handleStorageChange);
    window.addEventListener("tahunSiklusChanged", handleCustomChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      window.removeEventListener("tahunSiklusChanged", handleCustomChange);
    };
  }, []);

  const handleChange = (e) => {
    const val = parseInt(e.target.value, 10);
    localStorage.setItem("tahun_siklus", val);
    setSelectedYear(val);

    const event = new CustomEvent("tahunSiklusChanged", {
      detail: { year: val },
    });
    window.dispatchEvent(event);
    window.location.reload();
  };

  return (
    <Form.Control
      as="select"
      value={selectedYear}
      onChange={handleChange}
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.05)",
        border: "1px solid rgba(0, 0, 0, 0.1)",
        borderRadius: "5px",
        padding: "8px 12px",
        fontWeight: "bold",
        cursor: "pointer",
        minWidth: "120px",
        ...style
      }}
    >
      {Array.from({ length: 6 }, (_, i) => {
        const year = new Date().getFullYear() - 5 + i;
        return (
          <option key={year} value={year}>
            {year}
          </option>
        );
      })}
    </Form.Control>
  );
}
